import { ApiService } from "../../services/api.service";
import Cookies from "universal-cookie";
import { FormEvent, useEffect, useRef, useState } from "react";
import PageLoading from "../PageLoading/PageLoading";
import { useOutletContext } from "../../OutletContext";
import Swal from "sweetalert2";
import { adminPermissionsType, bankSupportType } from "../../types";
import { Divider, FormLabel, MenuItem, Select, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

const SettlementRequest = () => {
    const cookies = new Cookies(null, {path: '/'});
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const context = useOutletContext();
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    const [bankSupport, setBankSupport] = useState<bankSupportType[]>([]);

    const bankRef = useRef<HTMLSelectElement>(null);
    const bankAccNoRef = useRef<HTMLInputElement>(null);
    const bankAccNameRef = useRef<HTMLInputElement>(null);
    const amountRef = useRef<HTMLInputElement>(null);
    const remarkRef = useRef<HTMLInputElement>(null);
    const otpRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    useEffect(() => {
        getBankSupport();
    }, []);

    const getBankSupport = async () => {
        const bank_list = [];
        bank_list.push({
            bank_code: "CRYPTO",
            bank_abbr: "CRYPTO",
            bank_name_th: "CRYPTO",
            bank_name_en: "CRYPTO",
            bank_logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAYFBMVEX/mjD/mTH/mTL/mTP/ly3/pE//khj/lST//////fv/tnr/rmj/6tr/jgD/8OX/0Kv/5ND/yJz/07H/y6L/snD/8+r/9/D/nkH/jwv/ql//oUn/3cT/vYf/kx7/5tP/7uHJkUYqAAAA+UlEQVR4AWSSBZbFIAxFf9IgdXfb/y6HgUDt1SC30cMvCAAjIwT4veWIE74wI/D4hryNhEQku4M3Q6VjGSXwoBGLUp3lqS6k3XE+75eXuhK1bpTb34KCbGNt1Sm2BEegXrMKguDqFtKyYbBUOgcfVbXGWI3TNFZm0brAwFGn2LCcTMW5obHkuK6J2fw/kl0uaye5AYabyTdxtzsx+8K7PmEjvOCnoJ3AM/y0chSKGEIYQhGGMIzsexufoU79iBw1DH5vHIpbCSGqdzVxhRh0Mil8HBW73LWW/0/o5H5MkFI161Myeh0ioIjkiHfG8rZ7PtbfcCVqvNkBAI1GDnNjcE24AAAAAElFTkSuQmCC"
        });
        setBankSupport(bank_list);
        // try {
        //     const service = new ApiService();
        //     const getBank = await service.getBankSupport();

        //     if(getBank.data.status_code === 200)
        //     {
        //         const bank_list = getBank.data.bank_support;
        //         bank_list.push({
        //             bank_code: "CRYPTO",
        //             bank_abbr: "CRYPTO",
        //             bank_name_th: "CRYPTO",
        //             bank_name_en: "CRYPTO",
        //             bank_logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAYFBMVEX/mjD/mTH/mTL/mTP/ly3/pE//khj/lST//////fv/tnr/rmj/6tr/jgD/8OX/0Kv/5ND/yJz/07H/y6L/snD/8+r/9/D/nkH/jwv/ql//oUn/3cT/vYf/kx7/5tP/7uHJkUYqAAAA+UlEQVR4AWSSBZbFIAxFf9IgdXfb/y6HgUDt1SC30cMvCAAjIwT4veWIE74wI/D4hryNhEQku4M3Q6VjGSXwoBGLUp3lqS6k3XE+75eXuhK1bpTb34KCbGNt1Sm2BEegXrMKguDqFtKyYbBUOgcfVbXGWI3TNFZm0brAwFGn2LCcTMW5obHkuK6J2fw/kl0uaye5AYabyTdxtzsx+8K7PmEjvOCnoJ3AM/y0chSKGEIYQhGGMIzsexufoU79iBw1DH5vHIpbCSGqdzVxhRh0Mil8HBW73LWW/0/o5H5MkFI161Myeh0ioIjkiHfG8rZ7PtbfcCVqvNkBAI1GDnNjcE24AAAAAElFTkSuQmCC"
        //         });
        //         setBankSupport(getBank.data.bank_support);
        //     }
        // } catch (err) {
        //     console.log(err);
        // }
    }

    const handleRequest = async (e: FormEvent) => {
        e.preventDefault();

        setLoading(true);
        try {
            if(
                !bankRef.current ||
                !bankAccNoRef.current ||
                !bankAccNameRef.current ||
                !amountRef.current ||
                !remarkRef.current ||
                !otpRef.current
            )
            {
                return;
            }

            const bank = bankRef.current.value.trim();
            const accNo = bankAccNoRef.current.value.trim();
            const accName = bankAccNameRef.current.value.trim();
            const amount = amountRef.current.value.trim();
            const remark = remarkRef.current.value.trim();
            const otp = otpRef.current.value.trim();
            if(amount === '')
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Notification',
                    text: 'Please input amount !'
                });
            }
            else
            {
                const service = new ApiService();
                const request = await service.requestSettlement(cookies.get('access_token'), amount, remark, accNo, bank, accName, otp);

                if(request.data.status_code === 200)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Notification',
                        text: 'Request settlement successful'
                    }).then((res) => {
                        if(res)
                        {
                            navigate('/settlement-transactions');
                        }
                    });
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Notification',
                        text: `Request settlement fail (${request.data.status_code} - ${request.data.message})`
                    });
                }
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            <>
                <div className="col-12 mb-3">
                    <div className="card">
                        <div className="card-body">
                            <Typography component={'h1'} fontSize={22}>
                                Request settlement
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <form id="formRequestTransaction" className="mb-3" onSubmit={handleRequest} autoComplete="off">
                                <label htmlFor="select_bank" className="form-label"
                                    style={{ color: '#51659e' }}>
                                    Bank
                                </label>
                                <Select
                                    id="select_bank"
                                    name="select_bank"
                                    fullWidth
                                    size="small"
                                    inputRef={bankRef}
                                    sx={
                                        {
                                            backgroundColor: 'white',
                                            mb: 1
                                        }
                                    }
                                    defaultValue={`014`}
                                >
                                    {
                                        bankSupport.map((element: bankSupportType, index: number) => {
                                            return (
                                                <MenuItem value={element.bank_code} key={index}>
                                                    <Box display={`flex`} justifyContent={`flex-start`} alignContent={`center`} alignItems={`center`}>
                                                        <img src={element.bank_logo} alt={`bank_logo_${element.bank_abbr}`} style={{ maxWidth: 20 }} />
                                                        &nbsp;
                                                        {element.bank_name_en}
                                                    </Box>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                <div className="mb-1">
                                    <label htmlFor="bank_acc_no" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Bank account no / Crypto Address
                                    </label>
                                    <input type="tel" className="form-control" id="bank_acc_no" name="bank_acc_no"
                                        placeholder="Bank account no" ref={bankAccNoRef} />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="bank_acc_name" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Bank account name / Crypto Network
                                    </label>
                                    <input type="text" className="form-control" id="bank_acc_name" name="bank_acc_name"
                                        placeholder="Bank account name" ref={bankAccNameRef} />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="amount" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Amount (THB)
                                    </label>
                                    <input type="number" className="form-control" id="amount" name="amount"
                                        placeholder="Amount" ref={amountRef} />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="remark" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Remark
                                    </label>
                                    <input type="text" className="form-control" id="remark" name="remark"
                                        placeholder="Remark" ref={remarkRef} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="otp" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Authenticator
                                    </label>
                                    <input type={'text'} id="otp" className="form-control"
                                        name="otp" placeholder="Authenticator" ref={otpRef} />
                                </div>
                                <button className="btn btn-primary d-grid w-100" type="submit">Request</button>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default SettlementRequest;